<template lang="pug">
  tbody
    tr
      th(colspan=2) {{ cockfight_title }}
      td.text-center {{ cockfight_upline_pt }}%
      td.text-center(v-show="isSearch") {{ cockfight_account_pt }}%
      td.text-center(v-show="isSearch") {{ cockfight_upline_remaining}}%
      td.text-center(v-show="isSearch") {{ cockfight_account_min }}%
</template>

<script>
export default {
  props: {
    isSearch: false
  },
  data() {
    return {
      cockfight_upline_min: 0,
      cockfight_upline_max: 0,
      cockfight_upline_pt: 0,
      cockfight_account_pt: 0,
      cockfight_upline_remaining: 0,
      cockfight_account_min: 0
    }
  },
  computed: {
    cockfight_title: function () {
      return this.$t("ui.esports2") + " (" + this.cockfight_upline_min + "%-" + this.cockfight_upline_max + "%)"
    }
  }
}

</script>